import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "products-sort__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_select_vue = _resolveComponent("select-vue")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "products-sort",
        role: "region",
        "aria-label": _ctx.$t('product_list.header.sortBy')
      }, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('product_list.header.sortBy')), 1 /* TEXT */),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createVNode(_component_select_vue, {
          class: "products-sort__select select--formless",
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
          name: "sort",
          options: _ctx.options,
          "initial-value": _ctx.value
        }, null, 8 /* PROPS */, ["modelValue", "options", "initial-value"])
      ], 8 /* PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}